// ======================================================================
// File Name       : ReservedEmailListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues, isInvalid, reduxForm } from 'redux-form';
import * as ReservedEmailAction from '../../actions/ReservedEmailAction';
import ReservedEmailList from '../../components/email/ReservedEmailList';
import ReserveMailSearch from '../../components/email/ReservedEmailSearch';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import ModalConductor from '../../components/modal/ModalConductor';
import { DEFAULT_DATE_FORMAT_SERVER_NO_MINUTE, RETURN_MAX_NUM } from '../../constants';
import { RESERVED_EMAIL_DETAIL, RESERVED_EMAIL_LIST } from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';

class ReservedEmailListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {},
      isAllowShowSearchMessage: false,
    };
    this.initData = this.initData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.clickSearchButton = this.clickSearchButton.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentDidMount() {
    this.initData();
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.reservedEmailSortType) {
        column = initialValues.reservedEmailSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(initialValues, column, startPosition);
    this.props.dispatch(ReservedEmailAction.getReservedEmailList(param));
  }

  clickSearchButton() {
    const { formValues, invalid } = this.props;
    if (invalid) return;
    const filterData = {
      ...this.state.filterData,
      reservedEmailTitle: formValues.reservedEmailTitle,
      reservedDateFrom: formValues.reservedDateFrom,
      reservedDateTo: formValues.reservedDateTo,
      reservedEmailSortType: formValues.reservedEmailSortType,
      ascendingDescendingSort: formValues.ascendingDescendingSort,
      startPosition: formValues.startPosition,
    };
    this.setState({ filterData }, () => {
      const paramSearch = this.createParams(filterData, null, 0);
      this.props.change('startPosition', 0);
      this.props.change('reservedEmailSortType', null);
      this.props.change('ascendingDescendingSort', null);
      this.props.dispatch(ReservedEmailAction.getReservedEmailList(paramSearch))
      .then(() => {
        this.setState({ isAllowShowSearchMessage: true });
      });
    });
  }

  createParams(data, column, startPosition) {
    const filterData = {};
    if (data && data.reservedEmailTitle) {
      filterData.reservedEmailTitle = data.reservedEmailTitle;
    }
    if (data && data.reservedDateFrom) {
      const dateFrom = data.reservedDateFrom ? moment(data.reservedDateFrom).format(DEFAULT_DATE_FORMAT_SERVER_NO_MINUTE) : '';
      filterData.reservedDateFrom = dateFrom;
    }
    if (data && data.reservedDateTo) {
      const dateTo = data.reservedDateTo ? moment(data.reservedDateTo).format(DEFAULT_DATE_FORMAT_SERVER_NO_MINUTE) : '';
      filterData.reservedDateTo = dateTo;
    }
    if (!isNaN(parseInt(startPosition, 10))) {
      filterData.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      filterData.ascendingDescendingSort = column.sortState;
      filterData.reservedEmailSortType = column.sortBy;
    }

    if (!startPosition) {
      filterData.startPosition = 0;
    }
    filterData.returnMaxNum = RETURN_MAX_NUM;
    const param = {
      searchInfo: filterData,
    };
    return param;
  }

  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues && formValues.reservedEmailSortType) {
      column = formValues.reservedEmailSortType;
    }
    this.searchData(startPosition, column);
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let startPosition = null;
    if (formValues && formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }

  searchData(startPosition, column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    const paramSearch = this.createParams(formValues, column, startPosition);
    this.props.dispatch(ReservedEmailAction.getReservedEmailList(paramSearch))
    .then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  goToDetail(reservedMailInfo) {
    const path = RESERVED_EMAIL_DETAIL.replace(':id', reservedMailInfo.emailSenderIdAuto);
    this.props.history.push(path);
  }

  componentWillUnmount() {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: RESERVED_EMAIL_LIST,
        searchCondition: formValues,
      });
    }
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { reservedEmailList, invalid, recordNum } = this.props;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={reservedEmailList || []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <ReserveMailSearch
          onSearchBtnClick={this.clickSearchButton}
        />
        <ReservedEmailList
          reservedEmailList={reservedEmailList}
          handleSortState={this.handleSortState}
          invalid={invalid}
          goToDetail={this.goToDetail}
          getStartEndData={this.getStartEndData}
          recordNum={recordNum}
          hoverIndex={hoverIndex}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
        />
        <ModalConductor
          formKey="reserveEmailList"
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const invalid = isInvalid('reserveEmailList')(state);
  const { reservedEmailList, recordNum } = state.reservedEmail;
  const { parentPath, searchCondition } = state.page;
  let initial = {};
  if (parentPath === RESERVED_EMAIL_LIST) {
    initial = searchCondition;
  }
  return {
    invalid,
    reservedEmailList,
    recordNum,
    initialValues: initial,
    formValues: getFormValues('reserveEmailList')(state),
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'reserveEmailList',
  touchOnChange: true,
})(ReservedEmailListContainer));
